export const submitStaticForm = async (form) => {
    const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
            Accept: 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Form submission failed');
    }

    return response;
};
